import { Flex, Heading } from "@radix-ui/themes";
import { AppRedirectButtons } from "../../../shared/components/app-redirect-buttons.component";

export const UnitRentAppRequired: React.FC = () => {
  return (
    <Flex direction="column" gap="4" align="center" mt="4">
      <Heading as="h2" align="center" size="4">
        Willkommen beim E-Bike-Sharing der use Group!
      </Heading>

      <AppRedirectButtons message="Diese Einheit kann nur über unsere App gebucht werden. Bitte laden Sie die App herunter und scannen Sie den QR-Code mit der App." />
    </Flex>
  );
};
